/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable comma-dangle */
import './RedirectPage.css';

import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { RedirectToLogin, setCookie } from '../util/cookies';

function RedirectPage({ handleLogin }) {
  // Set dummy tenantDetails in sessionStorage
  const dummyTenantDetails = {
    requestorName: 'John Doe',
    requestorPhoneNumber: '1234567890',
    requestorEmail: 'john.doe@example.com',
    neighborhood: 'Neighborhood1',
    tenantCode: 'T123',
    address: '123 Main St',
    unitCode: 'U456',
    alternativeEmail: 'alt.john@example.com',
    alternativePhoneNumber: '0987654321',
    alternativePhoneNumberForText: '1122334455',
    accessNotes: 'Leave at door',
  };
  sessionStorage.setItem('tenantDetails', JSON.stringify(dummyTenantDetails));
  // Set tenant_code and neighborhood_code as cookies from tenantDetails
  setCookie('tenant_code', dummyTenantDetails.tenantCode, 1);
  setCookie('neighborhood_code', dummyTenantDetails.neighborhood, 1);
  const navigate = useNavigate();
  const sendTokenToBackend = async (code) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_WO_BACKEND_URL}/chat_bot_rasa/be/token_auth/`,
        { code },
        {
          withCredentials: true,
        }
      );

      if (response.data.status === 'success') {
        handleLogin();
        navigate('/chat');
      } else {
        // navigate('/login');
        RedirectToLogin();
      }
    } catch (error) {
      // navigate('/login');
      RedirectToLogin();
    }
  };
  useEffect(() => {
    // Set dummy tenantDetails in sessionStorage
    const dummyTenantDetails = {
      requestorName: 'John Doe',
      requestorPhoneNumber: '1234567890',
      requestorEmail: 'john.doe@example.com',
      neighborhood: 'Neighborhood1',
      tenantCode: 'T123',
      address: '123 Main St',
      unitCode: 'U456',
      alternativeEmail: 'alt.john@example.com',
      alternativePhoneNumber: '0987654321',
      alternativePhoneNumberForText: '1122334455',
      accessNotes: 'Leave at door',
    };
    sessionStorage.setItem('tenantDetails', JSON.stringify(dummyTenantDetails));

    // Extract the code from the URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    // Send the code to backend
    sendTokenToBackend(code);
  }, []);

  return (
    <div className="loader-container-ani">
      <div className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}
RedirectPage.propTypes = {
  handleLogin: PropTypes.func.isRequired,
};

export default RedirectPage;
